// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const likesHistoryConfig = {
    title: 'chart.twitter.likes_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.twitter.likes_history_name',
        avg: 'chart.twitter.likes_history_avg'
    },
    id: 'likes_history',
    color: {
        value: 'red',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
